export interface AccountPlacementExclusionList {
  ItemCount: number;
  AssociationCount: number;
  Id: number;
  Name: string;
}

export type ListType = 'block' | 'allow';

export type CampaignType = 'Audience' | 'BrandAwarenessVideoAds' | 'Search' | 'Display' | number | null;

export interface ListSelectorProps {
  listType: ListType
  selected?: AccountPlacementExclusionList[]
  onChange: (selected: any[]) => void
}

export const TEXT_CONTENT = {
  description: {
    block: _TL_('Add website exclusion lists to your campaign to help prevent your ads from being shown on certain websites. Note: You can create, edit, and view account-level lists in your Website control lists.'),
    allow: _TL_('Adding allowed website lists to this campaign is optional. This option helps you specify sites where you want your ads to appear, giving you more control over ad placement while still maintaining broader distribution across other sites.'),
  },
  listLabel: {
    block: _TL_('Blocked Lists'),
    allow: _TL_('Allowed Lists'),
  },
  ariaLabel: {
    block: _TL_('Select blocked website lists'),
    allow: _TL_('Select allowed website lists'),
  },
};
